module.exports = __webpack_public_path__ + "static/media/hero-contact.606229b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/contact/hero-contact.png
// module id = 253
// module chunks = 0